import crudFactory from "../crudFactory";

const MODEL = "dashboard-widget/widget-catalog";

const COMMON_CRUD_APIs = crudFactory(MODEL);

export default { ...COMMON_CRUD_APIs };
